import { Box, Text, VStack, Link } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  // Store Details
  businessUnitName?: string | null
  storeName?: string | null
  branchCode?: string | null
  contactPerson?: string | null
  email?: string | null
  contactNumber?: string | null
  storeAddress?: string | null
}

function Field({
  label,
  value,
}: {
  label: string
  value?: string | null
}) {
  const colors = useThemeColors()

  return (
    <Box w="100%">
      <Text fontSize="sm" color={colors.textSecondary} fontWeight="600" mb={0.5}>
        {label}
      </Text>
      <Text fontWeight="600" color={value ? colors.text : colors.textMuted}>
        {value || '—'}
      </Text>
    </Box>
  )
}

export default function StoreDetailsCard({
  businessUnitName,
  storeName,
  branchCode,
  contactPerson,
  email,
  contactNumber,
  storeAddress,
}: Props) {
  const colors = useThemeColors()

  return (
    <Box
      bg={colors.cardBg}
      borderRadius="lg"
      border="1px solid"
      borderColor={colors.border}
      overflow="hidden"
    >
      {/* Header */}
      <Box px={4} py={3} borderBottom="1px solid" borderColor={colors.borderLight}>
        <Text fontWeight="700" color={colors.primary}>
          Store Details
        </Text>
      </Box>

      {/* Body */}
      <Box px={4} py={3}>
        <VStack align="start" spacing={2}>
          <Field label="Business Unit Name:" value={businessUnitName} />
          <Field label="Store Name:" value={storeName} />
          <Field label="Branch Code:" value={branchCode} />
          <Field label="Contact Person:" value={contactPerson} />
          {email && (
            <Box w="100%">
              <Text fontSize="sm" color={colors.textSecondary} fontWeight="600" mb={0.5}>
                Email:
              </Text>
              <Link
                href={`mailto:${email}`}
                color={colors.email}
                fontWeight="600"
                _hover={{ color: colors.linkHover }}
              >
                {email}
              </Link>
            </Box>
          )}
          <Field label="Contact Number:" value={contactNumber} />
          <Field label="Store Address:" value={storeAddress} />
        </VStack>
      </Box>
    </Box>
  )
}
